import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("pgf-theme") || "dark");

  useEffect(() => {
    // Set data-theme on <html> for CSS [data-theme] selectors
    document.documentElement.setAttribute("data-theme", theme);
    // Set class on <body> for .theme-dark / .theme-light CSS selectors
    document.body.className = `theme-${theme}`;
    localStorage.setItem("pgf-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === "dark" ? "light" : "dark");

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark: theme === "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
